var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCustomerOnboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.957,
    height: 41.957,
    viewBox: "0 0 41.957 41.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33556",
    "data-name": "Group 33556",
    transform: "translate(-1577 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13737",
    "data-name": "Rectangle 13737",
    width: 41.957,
    height: 41.957,
    rx: 8,
    transform: "translate(1577 98)",
    fill: "#eff4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66727",
    "data-name": "Group 66727",
    transform: "translate(1590 109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93668",
    "data-name": "Path 93668",
    d: "M91.781,9.5a4.6,4.6,0,0,1-3.359-1.392A4.6,4.6,0,0,1,87.031,4.75a4.6,4.6,0,0,1,1.392-3.358,4.749,4.749,0,0,1,6.717,0A4.6,4.6,0,0,1,96.531,4.75,4.6,4.6,0,0,1,95.14,8.108,4.6,4.6,0,0,1,91.781,9.5Zm2.541-7.291a3.593,3.593,0,0,0-5.082,0A3.434,3.434,0,0,0,88.187,4.75,3.434,3.434,0,0,0,89.24,7.291a3.593,3.593,0,0,0,5.082,0A3.433,3.433,0,0,0,95.376,4.75,3.434,3.434,0,0,0,94.322,2.209Zm0,0",
    transform: "translate(-83.43)",
    fill: "#1162fb",
    stroke: "#1162fb",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93669",
    "data-name": "Path 93669",
    d: "M.04,252.955a11.732,11.732,0,0,1,.16-1.246,9.818,9.818,0,0,1,.306-1.253,6.189,6.189,0,0,1,.515-1.168,4.4,4.4,0,0,1,.777-1.012,3.424,3.424,0,0,1,1.116-.7,3.856,3.856,0,0,1,1.424-.258,1.446,1.446,0,0,1,.772.327c.231.151.5.325.8.518a4.609,4.609,0,0,0,1.041.458,4.041,4.041,0,0,0,2.545,0,4.6,4.6,0,0,0,1.04-.458c.3-.191.57-.366.8-.519a1.444,1.444,0,0,1,.772-.327,3.851,3.851,0,0,1,1.424.258,3.421,3.421,0,0,1,1.116.7,4.405,4.405,0,0,1,.776,1.012,6.2,6.2,0,0,1,.515,1.169,9.841,9.841,0,0,1,.306,1.253,11.652,11.652,0,0,1,.16,1.247c.026.377.039.769.039,1.165a3.275,3.275,0,0,1-.973,2.477,3.5,3.5,0,0,1-2.506.914h-9.5A3.5,3.5,0,0,1,.973,256.6,3.273,3.273,0,0,1,0,254.12C0,253.722.014,253.33.04,252.955Zm1.73,2.805a2.357,2.357,0,0,0,1.709.6h9.5a2.357,2.357,0,0,0,1.709-.6,2.138,2.138,0,0,0,.614-1.64c0-.37-.012-.734-.037-1.085a10.51,10.51,0,0,0-.144-1.122,8.679,8.679,0,0,0-.269-1.1,5.047,5.047,0,0,0-.419-.95,3.265,3.265,0,0,0-.571-.748,2.271,2.271,0,0,0-.742-.461,2.659,2.659,0,0,0-.91-.176c-.04.021-.113.063-.229.139-.238.155-.511.331-.814.525a5.727,5.727,0,0,1-1.306.584,5.2,5.2,0,0,1-3.256,0,5.733,5.733,0,0,1-1.307-.584c-.31-.2-.576-.37-.814-.524-.117-.076-.189-.117-.229-.139a2.66,2.66,0,0,0-.91.176,2.275,2.275,0,0,0-.742.461,3.256,3.256,0,0,0-.571.748,5.03,5.03,0,0,0-.419.95,8.658,8.658,0,0,0-.27,1.1,10.6,10.6,0,0,0-.144,1.123h0c-.025.349-.037.714-.037,1.084A2.138,2.138,0,0,0,1.77,255.76Zm0,0",
    transform: "translate(0 -237.79)",
    fill: "#1162fb",
    stroke: "#1162fb",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerOnboard);
export default __webpack_public_path__ + "static/media/IconCustomerOnboard.5eee7621.svg";
export { ForwardRef as ReactComponent };